/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetSlackDirectoryDefaultProjectRequestBody = {
  /**
   * Durable organization workspace connection ID.
   */
  id: string;
  /**
   * Project in the organization. Omit to clear the default project.
   */
  projectId?: string | undefined;
};

/** @internal */
export type SetSlackDirectoryDefaultProjectRequestBody$Outbound = {
  id: string;
  project_id?: string | undefined;
};

/** @internal */
export const SetSlackDirectoryDefaultProjectRequestBody$outboundSchema:
  z.ZodMiniType<
    SetSlackDirectoryDefaultProjectRequestBody$Outbound,
    SetSlackDirectoryDefaultProjectRequestBody
  > = z.pipe(
    z.object({
      id: z.string(),
      projectId: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectId: "project_id",
      });
    }),
  );

export function setSlackDirectoryDefaultProjectRequestBodyToJSON(
  setSlackDirectoryDefaultProjectRequestBody:
    SetSlackDirectoryDefaultProjectRequestBody,
): string {
  return JSON.stringify(
    SetSlackDirectoryDefaultProjectRequestBody$outboundSchema.parse(
      setSlackDirectoryDefaultProjectRequestBody,
    ),
  );
}
